import { workspaceModel } from 'APP/model/model';
import { WorkspaceRole } from 'APP/model/workspace/workspaceModel.types';
import Entities from 'STORE';

export async function changeWorkspaceOwnership(newOwnerId: string): Promise<boolean> {
  try {
    const result = await workspaceModel.changeOwnership(newOwnerId);

    if (result) {
      Entities.workspace.setRole(WorkspaceRole.ADMIN);
    }

    return result;
  } catch {
    return false;
  }
}
